import styled from "styled-components";

const WrapBackgroundImage = styled.div``;

export { WrapBackgroundImage };



// WEBPACK FOOTER //
// ./src/components/preview/Background.styled.tsx